import EnumRiskLevel from "@wallet-manager/node-types/dist/types/postgres/const/RiskLevel";

const enumRawRiskLevelSelection = {
  NoAssessment: EnumRiskLevel.NoAssessment,
  NoRiskDetected: EnumRiskLevel.NoRiskDetected,
  Info: EnumRiskLevel.Info,
  Caution: EnumRiskLevel.Caution,
  Medium: EnumRiskLevel.Medium,
  High: EnumRiskLevel.High,
  Critical: EnumRiskLevel.Critical,
};

export function getEnumRiskByMerchantLevel(merchantLevel: number) {
  let riskLevelObj: Record<string, string> = { risk_acceptant: "acceptant" };
  let acceptantLevelObj: Record<string, string> = {};
  for (let key_ in enumRawRiskLevelSelection) {
    const key = key_ as keyof typeof enumRawRiskLevelSelection;
    const val = enumRawRiskLevelSelection[key];
    if (val > merchantLevel) {
      riskLevelObj[key] = String(val);
    } else {
      acceptantLevelObj[key] = String(val);
    }
  }
  return { risk: riskLevelObj, acceptant: acceptantLevelObj };
}
